
import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { ProfileTypeField } from "./ProfileTypeField";
import { FormData, FormErrors } from "./types";

interface ContactFormFieldsProps {
  formData: FormData;
  errors: FormErrors;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onSelectChange: (name: string, value: string) => void;
}

export const ContactFormFields: React.FC<ContactFormFieldsProps> = ({
  formData,
  errors,
  onChange,
  onSelectChange
}) => {
  return (
    <>
      <ProfileTypeField
        value={formData.profileType}
        onValueChange={onSelectChange}
        error={errors.profileType}
      />
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label htmlFor="name" className="block mb-2 font-medium text-gray-700">
            Nom complet*
          </label>
          <Input
            id="name"
            name="name"
            value={formData.name}
            onChange={onChange}
            placeholder="Votre nom"
            className={errors.name ? 'border-red-500' : ''}
          />
          {errors.name && <p className="mt-1 text-sm text-red-600">{errors.name}</p>}
        </div>
        
        <div>
          <label htmlFor="email" className="block mb-2 font-medium text-gray-700">
            Email*
          </label>
          <Input
            id="email"
            name="email"
            type="email"
            value={formData.email}
            onChange={onChange}
            placeholder="Votre email"
            className={errors.email ? 'border-red-500' : ''}
          />
          {errors.email && <p className="mt-1 text-sm text-red-600">{errors.email}</p>}
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label htmlFor="phone" className="block mb-2 font-medium text-gray-700">
            Téléphone
          </label>
          <Input
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={onChange}
            placeholder="Votre numéro de téléphone"
          />
        </div>
        
        <div>
          <label htmlFor="subject" className="block mb-2 font-medium text-gray-700">
            Sujet*
          </label>
          <Input
            id="subject"
            name="subject"
            value={formData.subject}
            onChange={onChange}
            placeholder="Sujet de votre message"
            className={errors.subject ? 'border-red-500' : ''}
          />
          {errors.subject && <p className="mt-1 text-sm text-red-600">{errors.subject}</p>}
        </div>
      </div>
      
      <div>
        <label htmlFor="message" className="block mb-2 font-medium text-gray-700">
          Message*
        </label>
        <Textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={onChange}
          placeholder="Votre message"
          rows={6}
          className={errors.message ? 'border-red-500' : ''}
        />
        {errors.message && <p className="mt-1 text-sm text-red-600">{errors.message}</p>}
      </div>
    </>
  );
};
